module.exports = __webpack_public_path__ + "static/media/ES-Upf.ccd8c64c.png";